export default __webpack_public_path__ + "static/media/lc-img.496c0305.webp";